import { LineChart } from '@mui/x-charts';
import { useGetAdminCompetitionItemRatingHistoryQuery } from 'entities/competitions-b2b';
import React, { FC } from 'react';
import { CircularLoader } from 'shared/ui/CircularLoader/CircularLoader';
import { MoreInfo } from 'shared/ui';
import { Box } from '@mui/system';
import { ICompetitionSalesPointRatingStatsWidget, ICompetitionSalesPointRatingStatsWidgetFlow } from './types';
import { useSalesPointGenerateLineChart } from './lib';

const CompetitionSalesPointRatingStatsWidget: FC<ICompetitionSalesPointRatingStatsWidget> = ({
  competitionId,
  participantId,
  flow = ICompetitionSalesPointRatingStatsWidgetFlow.place,
  label,
}) => {
  const { data, isLoading } = useGetAdminCompetitionItemRatingHistoryQuery({ competitionId, participantId });
  const { xAxis, series } = useSalesPointGenerateLineChart(data, flow);

  if (isLoading) return <CircularLoader />;

  if (!data) return <div>При получении данных произошла ошибка</div>;

  return (
    <div style={{ width: '100%' }}>
      <div style={{ padding: 16 }}>
        <MoreInfo>
          <Box sx={{ color: 'rgba(0, 0, 0, 0.70)', fontSize: 14 }}>{label}</Box>
        </MoreInfo>
      </div>
      <LineChart
        disableAxisListener
        sx={{
          '.MuiLineElement-root': {
            stroke: '#2330C5',
            strokeWidth: 2,
          },
          '.MuiMarkElement-root': {
            stroke: '#2330C5',
            strokeWidth: 2,
          },
        }}
        xAxis={xAxis}
        series={series}
        width={420}
        height={220}
      />
    </div>
  );
};

export { CompetitionSalesPointRatingStatsWidget };
